export var ThirdParty;
(function (ThirdParty) {
    /** 跳转或打开页面目标类型 */
    let PageTarget;
    (function (PageTarget) {
        /** 当前页面 */
        PageTarget["Current"] = "current";
        /** 新页面 */
        PageTarget["Blank"] = "blank";
        /** 浏览器 */
        PageTarget["Browser"] = "browser";
    })(PageTarget = ThirdParty.PageTarget || (ThirdParty.PageTarget = {}));
    /** 文件上传或下载平台类型 */
    let FileOperationPlatform;
    (function (FileOperationPlatform) {
        /** 普通上传/下载 */
        FileOperationPlatform["Common"] = "Common";
        /** 上传/下载到微盘 */
        FileOperationPlatform["WeDrive"] = "WeDrive";
    })(FileOperationPlatform = ThirdParty.FileOperationPlatform || (ThirdParty.FileOperationPlatform = {}));
})(ThirdParty || (ThirdParty = {}));
